/**
 * Created by USER on 18/5/18.
 */
export const CHANGEBAR_STATE = 'CHANGEBAR_STATE'; // 控制顶部栏的变化
export const CHANGE_LANGUAGE = 'CHANGE_LANGUAGE'; // 语言的切换
export const CHANGE_OFFSETWIDTH = 'CHANGE_OFFSETWIDTH'; // 宽度

export function changeBarState(data) {
  return {
    type: CHANGEBAR_STATE,
    data
  };
}

export function changeLanguage(data) {
  return {
    type: CHANGE_LANGUAGE,
    data
  };
}

export function changeOffsetWidth(data) {
  return {
    type: CHANGE_OFFSETWIDTH,
    data
  };
}



